import { ChangeEvent, FC, memo } from "react";
import styles from "./ReportProduct.module.scss";
import {
  DealerKeysEnum,
  IReportProduct,
  ReportDealerInfoType,
  ReportType,
} from "@/entities/report/types";
import {
  TableInfoType,
  FilialsTableInfoType,
  ProductTotalsType,
  FilialInfoType,
} from "@/widgets/tables/reportTable/types/types";

import clsx from "clsx";
import { ReportHeader } from "../reportHeader/ReportHeader";
const ROW_HEIGHT = 50;
interface ReportProductProps {
  product: IReportProduct;
  dealer: ReportDealerInfoType;
  reportStatus: ReportType;
  isDraft: boolean;
  totalView?: boolean;
  isFilialView?: boolean;
  productsDealerData: TableInfoType | null;
  reservedData: FilialsTableInfoType | null;
  productTotals?: ProductTotalsType;
  productDealerFilialTotals: FilialInfoType;
  dealerMainId: string;
  hasBranch: boolean;
  headers: Array<
    keyof typeof DealerKeysEnum | "productionPlanQuantity" | "remainsQuantity"
  >;
  sortIndex: number;
  selectedProductId: string;
  getMainDealerTotalValue: (
    productId: string,
    dealer: ReportDealerInfoType,
    productData: TableInfoType | null,
    keyName: keyof ReportDealerInfoType,
  ) => number;
  handleBlur: (
    e: ChangeEvent<HTMLInputElement>,
    tempValue: number,
    dealerOrderItem: ReportDealerInfoType,
    hasBranch: boolean,
  ) => void;
}

const ReportProductComponent: FC<ReportProductProps> = ({
  product,
  dealer,
  totalView = false,
  isFilialView = false,
  reportStatus,
  isDraft,
  productsDealerData,
  productTotals,
  reservedData,
  productDealerFilialTotals,
  dealerMainId,
  hasBranch,
  headers,
  sortIndex,
  selectedProductId,
  getMainDealerTotalValue,
  handleBlur,
}) => {
  const dealerOrderItem = product.dealerOrderItems.find(
    (d) => d.dealerId === dealer.dealerId,
  );

  return (
    <tr
      style={{
        transform: `translateY(${sortIndex * ROW_HEIGHT}px)`,
        position: "absolute",
        height: ROW_HEIGHT,
        width: "100%",
      }}
      key={product.vendorId}
      className={clsx(
        styles.row,
        sortIndex % 2 === 0 ? styles.whiteBg : styles.grayBg,
        {
          [styles.selectedRow]: selectedProductId === product.vendorId,
          [styles.unselectedRow]:
            selectedProductId && selectedProductId !== product.vendorId,
        },
      )}
    >
      {headers.map((el) => (
        <ReportHeader
          key={product.vendorId + el}
          totalView={totalView}
          isFilialView={isFilialView}
          reportStatus={reportStatus}
          isDraft={isDraft}
          productsDealerData={productsDealerData}
          productTotals={productTotals}
          reservedData={reservedData}
          productDealerFilialTotals={productDealerFilialTotals}
          dealerMainId={dealerMainId}
          hasBranch={hasBranch}
          selectedProductId={selectedProductId}
          getMainDealerTotalValue={getMainDealerTotalValue}
          handleBlur={handleBlur}
          product={product}
          dealer={dealer}
          el={el}
          dealerOrderItem={dealerOrderItem}
        />
      ))}
    </tr>
  );
};

export const ReportProduct = memo(ReportProductComponent);
